import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Isvg from 'react-inlinesvg'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import interactiveVideoActions from 'redux/actions/interactiveVideoActions'
import { localize } from 'helpers/translator'
import Modalizer from 'components/modalizer/modalizer'
import NotificationBox from 'components/notification_box/notification_box'
import tooltipTypes from 'helpers/enums/tooltipTypes'

import scissors from 'assets/views/interactive_video/editor/scissors.svg'

const scissorsIcon = <Isvg src={scissors} cacheGetRequests={true} />

const InteractiveVideoTrimTooltipContainer = props => {

	const gotIt = useCallback(() => {
		props.actions.gotIt(tooltipTypes.INTERACTIVE_VIDEO_EDITOR_WILL_TRIM_ACTIVITIES)
	}, [props.actions])

	return (
		<Modalizer
			closeButton={false}
			noPadding
			boxed={false}
		>
			<NotificationBox
				icon={scissorsIcon}
				text={localize('interactive_video_trim_video_notification_message')}
				btTwo={localize('global_tooltip_gotIt')}
				actionTwo={gotIt}
			/>
		</Modalizer>
	)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		gotIt: interactiveVideoActions.trimToolTrimTooltipGotIt,
	}, dispatch)
}

InteractiveVideoTrimTooltipContainer.propTypes = {
	actions: PropTypes.shape({
		gotIt: PropTypes.func.isRequired,
	}),
}

export default connect(null, mapDispatchToProps)(InteractiveVideoTrimTooltipContainer)

export { InteractiveVideoTrimTooltipContainer }
